import { render, staticRenderFns } from "./SeasonWidget.vue?vue&type=template&id=02003444&scoped=true&"
import script from "./SeasonWidget.vue?vue&type=script&lang=js&"
export * from "./SeasonWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02003444",
  null
  
)

export default component.exports